import { render, staticRenderFns } from "./copy5.vue?vue&type=template&id=2796a894&scoped=true"
import script from "./copy5.vue?vue&type=script&lang=js"
export * from "./copy5.vue?vue&type=script&lang=js"
import style0 from "./copy5.vue?vue&type=style&index=0&id=2796a894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2796a894",
  null
  
)

export default component.exports